// This should be determined by the rangePrincipalMin of the pricing
export const MIN_LOAN_AMOUNT = 3000;

//Determined by term and antiquity of the vehicle. cannot be greater than Max_loan_term
export const MAX_LOAN_TERM = 156;
export const MAX_LOAN_TERM_FACILITEA = 144;

export const getMinDownPaymentValueByAssetAmount = (assetAmount) => {
  return 0;
  // switch (true) {
  //   case assetAmount <= 50000:
  //     return 0;
  //   case assetAmount > 50000 && assetAmount <= 100000:
  //     return 0.1 * assetAmount;
  //   case assetAmount > 100000 && assetAmount <= 150000:
  //     return 0.15 * assetAmount;
  //   case assetAmount > 150000:
  //     return 0.2 * assetAmount;
  //   default:
  //     return 0;
  // }
};
